/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TrueGritGameAssets} from "../TrueGritGameAssets";
import {TrueGrit} from "../TrueGrit";
import {TrueGritGameMode} from "../server/TrueGritGameMode";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class TrueGritBackgroundElements extends PIXI.Container implements StageLayer {

    private _backgroundMain:PIXI.Sprite;
    private _backgroundMainContainer:PIXI.Container;
    private _backgroundFS:PIXI.Sprite;
    private _darkLayerFS:PIXI.Sprite;
    private _backgroundFSContainer:PIXI.Container;
    private _backgroundSuperFS:PIXI.Sprite;
    private _darkLayerSuperFS:PIXI.Sprite;
    private _backgroundSuperFSContainer:PIXI.Container;
    private _fadeInTimeline:gsap.core.Timeline;

    constructor() {
        super();
        this.name = "TrueGritBackgroundElements";
        this.init();
    }

    private init() {
        this._backgroundMain = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.MAIN_GAME_BACKGROUND)[0]);
        this._backgroundMain.position.set(360, 360);
        this._backgroundMain.anchor.set(0.5, 0.5);
        this._backgroundMainContainer = new PIXI.Container();
        this._backgroundMainContainer.addChild(this._backgroundMain);
        this.addChild(this._backgroundMainContainer);

        this._backgroundFS = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.MAIN_GAME_BACKGROUND)[0]);
        this._backgroundFS.position.set(360, 360);
        this._backgroundFS.anchor.set(0.5, 0.5);
        this._backgroundFSContainer = new PIXI.Container();
        this._backgroundFSContainer.alpha = 0;
        this._backgroundFSContainer.addChild(this._backgroundFS);
        this._darkLayerFS = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._darkLayerFS.tint = 0x000000;
        this._darkLayerFS.alpha = 0.26;
        this._backgroundFSContainer.addChild(this._darkLayerFS);
        this.addChild(this._backgroundFSContainer);

        this._backgroundSuperFS = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.MAIN_GAME_BACKGROUND)[0]);
        this._backgroundSuperFS.position.set(360, 360);
        this._backgroundSuperFS.anchor.set(0.5, 0.5);
        this._backgroundSuperFSContainer = new PIXI.Container();
        this._backgroundSuperFSContainer.alpha = 0;
        this._backgroundSuperFSContainer.addChild(this._backgroundSuperFS);
        this._darkLayerSuperFS = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._darkLayerSuperFS.tint = 0x000000;
        this._darkLayerSuperFS.alpha = 0.51;
        this._backgroundSuperFSContainer.addChild(this._darkLayerSuperFS);
        this.addChild(this._backgroundSuperFSContainer);

        this.onResize();
    }

    private swapBackgroundTo(newBackground:PIXI.Container, fadeInTime:number) {
        newBackground.alpha = 0;
        this.addChild(newBackground);
        this._fadeInTimeline = new gsap.core.Timeline();
        this._fadeInTimeline.add(gsap.to(newBackground, {duration : fadeInTime, alpha : 1}));
        this._fadeInTimeline.add(() => {
            for(let i:number = 0; i < this.children.length - 1; i++) {
                this.children[i].alpha = 0;
            }
        })
    }

    public setMode(mode:string, fadeInTime:number = 0) {
        if(mode == TrueGritGameMode.FREESPIN || mode == TrueGritGameMode.FREESPIN_AVALANCHE) {
            this.swapBackgroundTo(this._backgroundFSContainer, fadeInTime);
        } else if(mode == TrueGritGameMode.FREESPIN_SUPER || (mode == TrueGritGameMode.FREESPIN_SUPER_AVALANCHE)) {
            this.swapBackgroundTo(this._backgroundSuperFSContainer, fadeInTime);
        } else {
            this.swapBackgroundTo(this._backgroundMainContainer, fadeInTime);
        }
    }

    onResize():void {
        this._darkLayerFS.width = NolimitApplication.screenBounds.width;
        this._darkLayerFS.height = NolimitApplication.screenBounds.height;
        this._darkLayerFS.x = NolimitApplication.screenBounds.left;
        this._darkLayerFS.y = NolimitApplication.screenBounds.top;

        this._darkLayerSuperFS.width = NolimitApplication.screenBounds.width;
        this._darkLayerSuperFS.height = NolimitApplication.screenBounds.height;
        this._darkLayerSuperFS.x = NolimitApplication.screenBounds.left;
        this._darkLayerSuperFS.y = NolimitApplication.screenBounds.top;
    }
}